'use client';

import { useWebHaptics } from 'web-haptics/react';

import Link from 'next/link';

import button from '@/styles/button.module.sass';
import text from '@/styles/text.module.sass';
import styles from './Profile.module.sass';

export default function ProfileLoading() {
  const { trigger } = useWebHaptics();

  return (
    <>
      <div className={styles.horizontalWrapper}>
        <h1 className={text.h1}>Hi,</h1>
        <div className={styles.imageLoading}></div>
        <h1 className={text.h1}>
          <span className={text.loading}>{'User'}</span>
        </h1>
      </div>

      <p className={text.p}>
        <span className={text.loading}>Loading...</span>
        <br />
        <span className={text.loading}>Loading your plan...</span>
      </p>
      <div className={button.vWrapper}>
        <Link
          style={{ marginTop: '24px' }}
          className={button.accentLoading}
          href="#"
          onClick={() => trigger('medium')}
          aria-disabled="true"
        >
          Manage subscription
        </Link>
        <button
          className={button.secondaryLoading}
          onClick={() => trigger('medium')}
          aria-disabled="true"
        >
          Sign out
        </button>
      </div>
    </>
  );
}
